import Controller from "./IHSakaiMuchaController";

/**
 *
 * @type {module.IHSakaiMucha}
 */
module.exports = class IHSakaiMucha extends IH{
  constructor(options) {
    super(options);
    this.options = options;
    this.mapOptions.olmap_options.useOnlineOSM = false;
    this.repositoryOptions = {
      type: 'facet',
      placeTypeFacetName: '種別',
      searchApi: 'search',
      mappingItems: {
        lat: 'lat',
        lng: 'lng',
        image: 'image',
        image_label: 'image_label',
        name: '作品名',
        address: '',
        description: '',
        info: 'info'
      },
      sortTarget: {
        kana: '作品名',
        year: '制作年'
      },
      firstSelection: 'ポスター'
    };
    this.defaultSortKey = 'year';
    this.defaultSortOrder = 1;
    this.sortKey_1 = 'year';
    this.sortOrder_1 = 1;
    this.detailMenus = ['No', '作品名（英文）', '制作年', '技法・材質等', '寸法'];
    this.searchTargetTypes = [];
    this.show_direction_on_marker_click = false;
    this.defaultView = 'tile';
  }

  createController (options) {
    return new Controller(options);
  }

  reset() {
    super.reset();
    this.init();
  }
  
  init() {
    let that = this;
    
    $(that).on('ready', () => {
      this.customizedSearch ()
      this.expandOneSearchMenuAlways();

      // 詳細パネルとマーカーポップアップの内容の書き換え
      $(that).on('ihFillMarkerPopup', function(event, place, popup) {
        // 詳細パネル: アプリ固有の項目を作成する
        that.createDetailMenus(place, popup);
        // 詳細パネル: 画像ポップアップを作成する
        that.createImagePopup(place, popup);
      });

      // 検索結果一覧に作品番号を表示
      $(this).on('ihFillSearchResult', function(event, place, button) {
        button.find('.mc-sr-no').text(`${place.attributes.No}. `);
      });

      // ファセット値未選択時は種別ファセット以外閉じる
      $(this.controller).on('ihAfterUpdateFacetValue', () => {
        if (this.isNotFacetValueSelected()) {
          this.collapseFacetsWithoutTypeFacet();
        }
      });
    });
  }
  
  /**
   *
   * @override
   * @protected
   */
  beforeStart() {
    return this.initFacets();
  }
  
  /**
   * ファセット一覧を取得して施設タイプを設定する
   *
   * @returns {*}
   */
  initFacets() {
    return this.repository.loadFacets().then(() => {
      this.setOptionsForPlaceTypes(this.repository.getPlaceTypes());
    });
  }
  
  /**
   * 詳細パネル: アプリ固有の項目を作成する
   *
   * @param place
   * @param popup
   */
  createDetailMenus(place, popup){
    for (let i = 0, len = this.detailMenus.length; i < len; i++ ) {
      let attr = this.detailMenus[i];
      let text = '';
      
      // 施設オブジェクトに項目名と同じプロパティがあり、プロパティ値が空で無ければ項目の内容として表示
      if (attr in place.attributes && place.attributes[attr] !== '') {
        text = place.attributes[attr];
        if (attr === '技法・材質等') {
          attr = '技法・材質';
        }
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').find('.iw-label').text(attr);
        popup.find('.iw-facet-' + (i+1)).html(text);
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').show();
      } else {
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').hide();
      }
    }
  }
  
  /**
   * 詳細パネル: 画像スライダー付きポップアップウィンドウを作成する
   *
   * @param place
   * @param popup
   */
  createImagePopup(place, popup){
    if ( place.image && popup.find('.iw-image-popup').length ){
      let imagePaths = place.image.split('|');                   // 画像パス ( 複数指定の場合、区切り文字は '|' )
      let imageTitle = place.attributes['作品名'].split('|')[0];    // 画像名称 ( 複数指定の場合、区切り文字は '|' )
      let numOfImages = imagePaths.length;                       // 画像枚数
      
      // 画像パスを整形
      for(let i = 0; i < numOfImages; i++) {
        // 改行や空白を削除
        imagePaths[i] = imagePaths[i].replace(/[\n\r\s]/g, '');
        
        // 画像パスがURLでなければ、ローカルパスを追加
        if (!imagePaths[i].match(/^http/)) {
          imagePaths[i] = this.place_image_path + imagePaths[i];
        }
      }
      
      // 画像枚数が2枚以上なら、ポップアップボタンの下に枚数表示
      if(numOfImages > 1){
        $('.iw-image-count').each(function () {
          $(this).text(numOfImages + '枚');
        });
      } else {
        $('.iw-image-count').each(function () {
          $(this).text('');
        });
      }
      
      popup.find('.iw-image-popup').show();
      let imagePopupContainer = popup.find('.iw-image-popup .iw-label');
      let imagePopup = $('#image-popup');
      
      // 画像ポップアップウィンドウとスライダの作成
      if ( imagePopup.length === 0 ){
        imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo( imagePopupContainer );
        //var imagePopupClose = $('<a href="#" data-rel="back" data-role="button" data-theme="a" class="ui-btn-right ui-btn ui-shadow ui-btn-corner-all ui-btn-icon-notext ui-btn-up-a"><span class="ui-btn-inner"><span class="ui-btn-text">Close</span><span class="ui-icon ui-icon-delete ui-icon-shadow">&nbsp;</span></span></a>').appendTo( imagePopup);
        //var img = $('<img>').appendTo( imagePopup );
        
        imagePopup.popup();
        
        // ヘッダーにポップアップを閉じるボタンを追加
        let closer = $('<button id="image-popup-closer" data-theme="f" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-f">閉じる</button>');
        closer.appendTo(imagePopup);
        closer.on('click', function () {
          imagePopup.popup('close');
        });
        
        // ポップアップを閉じるボタンのデザイン
        // ここで設定しないとデザインが反映されない
        closer.css({
          'padding': '5px 12px',
          'font-size': '1em'
        });
      }
      
      $('#image-slider').remove();
      $('.bx-wrapper').remove();
      
      // スライダー用のdiv要素を作成し、ポップアップウィンドウに追加
      let imageSlider = $('<div id="image-slider"></div>');
      imageSlider.appendTo(imagePopup);
      
      // img要素のtitle属性（スライダのキャプションに利用される）
      let title = '';
      
      // img要素を作成し、スライダー用divに追加
      for(let i = 0; i < numOfImages; i++) {
        
        // 画像は1枚目のみ読み込み、他はスライド直前に読み込み（遅延ロード）
        // 遅延ロードさせないと、ポップアップウィンドウ表示時に画像が一瞬縦に並んでしまう
        if (i === 0) {
          $('<div class="sliding-images"><img src="' + imagePaths[i] + '" title="' + imageTitle + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
          // this.adjustAspectRatio(i);
        } else {
          $('<div class="sliding-images"><img title="' + imageTitle + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        }
      }
      
      // ポップアップウィンドウの表示完了後にスライダを作成
      // これまでスライド作成できない不具合があったのは、恐らくポップアップ表示完了前にスライダが生成されいたため
      imagePopup.on( "popupafteropen", ( event, ui )=> {
        imageSlider.bxSlider({
          minSlides: 1,
          maxSlides: 1,
          slideMargin: 5,
          infiniteLoop: false,
          hideControlOnEnd: true,
          captions: true,
          // 画像遅延ロード
          onSlideBefore: ($slideElement, oldIndex, newIndex) => {
            $('#sliding-image-' + newIndex).attr('src', imagePaths[newIndex]);
            // this.adjustAspectRatio(newIndex);
          },
          onSliderLoad: currentIndex => {
            // 画像の高さ指定（CSSで指定していると、画面サイズによっては縦横比が乱れることがあるため）
            $('.bx-wrapper .sliding-images img').css('max-height', '95%');

            // スライダーロード時にポップアップが左にずれることがあるため left 値を調整
            const popup = $('#image-popup-popup')
            const popupWidth = popup.width();
            const appWidth = $('#home').width();
            const popupSideMargin = (appWidth - popupWidth) / 2;
            popup.css('left', popupSideMargin);
            
            // 2枚目の画像が少し見えてしまう場合があるのでリドローして修復
            imageSlider.redrawSlider();
          }
        });
      });
    }else{
      popup.find('.iw-image-popup').hide();
    }
    
    if (place.image_label && popup.find('.iw-image-label').length){
      popup.find('.iw-image-label-item').show();
      popup.find('.iw-image-label').text(place.image_label);
    }else{
      popup.find('.iw-image-label-item').hide();
    }
  }
  
  /**
   * @override
   * @returns {Array}
   */
  getSearchTargetTypes(){
    let types = [];
    for (let i in this.searchTargetTypes){
      if (this.searchTargetTypes[i]){
        types.push(i);
      }
    }
    return types;
  }

  /**
   * 種類で検索・名前で検索は必ず一方が開いた状態とする
   */
  expandOneSearchMenuAlways () {
    $('.ih-search-menu').on('collapse', function () { 
      const $otherSearchMenu = $(this).parent().siblings('.ui-collapsible-set').find('.ih-search-menu');
      if ($otherSearchMenu.hasClass('ui-collapsible-collapsed')) {
        $otherSearchMenu.trigger('expand');
      }
    });
    $('.ih-search-menu').on('expand', function () { 
      const $otherSearchMenu = $(this).parent().siblings('.ui-collapsible-set').find('.ih-search-menu');
      if (!$otherSearchMenu.hasClass('ui-collapsible-collapsed')) {
        $otherSearchMenu.trigger('collapse');
      }
    });
  }
  
  /**
   * カルーセルの画像の縦横比補正
   * @param imageNumber
   */
  adjustAspectRatio (imageNumber) {
    setTimeout(() => {
      const img = $('#sliding-image-' + imageNumber);
      const height = img.height() + 0.1;
      img.height(height);
    }, 2000)
  }
  
  /**
   * カスタム検索（ハッシュタグ検索）
   */
  customizedSearch () {
    const $allClear = $('#all-clear');
    const $allClearButton = $('#all-clear-button');
    const $sortMenu = $('select.ih-result-sort-menu');
    const $sortOption = $('.mc-sort-option-customized');
    let $hashtag = null;

    // ハッシュタグボタン選択でカスタム検索実行
    $('.mc-customized-search-pickup').on('click', event => {
      $hashtag = $(event.currentTarget);
      const facetItemName = $hashtag.data('facet');
      const facetItemId = this.placeType.getIdByName(facetItemName);
      
      // カスタム検索専用の検索結果の並替えを設定
      this.sortKey_2 = facetItemName;
      this.repository.sortKey = facetItemName;
      this.sortOrder_2 = 1;
      this.repository.sortOrder = 1;
      $sortOption.prop('disabled', false);
      $sortMenu.val('2').selectmenu('refresh');

      // カスタム検索実行
      this.controller.clearAllSelector();
      this.searchTargetTypes = [];
      this.searchTargetTypes[facetItemId] = true;
      this.searchFromBaseMarker();

      // カスタム検索中は全選択解除ボタンの名称を変更
      $allClearButton.prop('disabled', false);
      $allClear.find('.ui-btn-inner').css('color', 'black');
      $allClear.find('.ui-btn-text').text('見どころによる選択を解除');
    });

    // カスタム検索中に全選択解除ボタンを選択した場合の処理
    $allClearButton.on('click', () => {
      if ($hashtag) {
        // 全選択解除ボタンの名称を通常に戻す
        $allClear.find('.ui-btn-text').text('選択を解除');
        $hashtag = null;

        // 並び替えを制作年代順に戻す
        this.repository.sortKey = 'year';
        this.repository.sortOrder = 1;
        $sortMenu.val('1').selectmenu('refresh');
        $sortOption.prop('disabled', true);
      }
    });
  
    // カスタム検索中は全選択解除ボタンは常に有効にする
    $('.js-facet-selector').on('changeState', () => {
      if ($hashtag) {
        $allClearButton.prop('disabled', false);
        $allClear.find('.ui-btn-inner').css('color', 'black');
      }
    });
  }

  /**
   * 種別ファセット以外を閉じる
   */
  collapseFacetsWithoutTypeFacet () {
    $('.ih-collapsible-search-menu-marker').each((index, element) => {
      const targetFacetId = 12;
      const facetId = parseInt($(element).data('facetId'));
      const isCollapsed = $(element).data('collapse');
      if ( facetId === targetFacetId && isCollapsed ) {              
        $(`.js-facility-category[data-category="${facetId}"]`).trigger('click');
      }
      if ( facetId !== targetFacetId && !isCollapsed ) {              
        $(`.js-facility-category[data-category="${facetId}"]`).trigger('click');
      }
    });
  }

  /**
   * ファセット値が選択されているかどうかを判定
   * 
   * @returns {boolean}
   */
  isNotFacetValueSelected () {
    let result = true;
    $('.js-facet-selector').each((index, element) => {
      if ($(element).prop('checked')) {
        result = false;
      }
    });
    return result;
  }

  /**
   * 企画展パネルでの展示トピック作品限定検索と関連処理
   */
  featureSearch () {
    const that = this;
    const $exhibitionPanel = $('#mc-page-feature');
    const $exhibitionMenu = $exhibitionPanel.find('.ui-collapsible h3');
    const $allClear = $('#all-clear');
    const $allClearButton = $('#all-clear-button');
    const $sortMenu = $('select.ih-result-sort-menu');
    const $sortOptionFeature = $('.mc-sort-option-feature');
    let $topic = null;
    
    $exhibitionMenu.on('click', function () {
      const $content = $exhibitionPanel.find('.panel-content');
      const headerHeight = $exhibitionPanel.find('.ui-header').height();
      const number = parseInt($(this).data('number'), 10);
      let position = $(this).position().top - headerHeight;
      if (number > 0) {
        position = 57 * number;
      }
      $content.animate( {scrollTop: position}, 200, 'swing' );
    });

    $('.mc-special-exhibition-topic').on('click', function () {
      $topic = $(this);
      const facetItemName = $topic.val();
      const facetItemId = that.placeType.getIdByName(facetItemName);
      
      // 結果一覧の並び順を特集専用にする(展示トピックの展示順)
      that.sortKey_2 = facetItemName;
      that.repository.sortKey = facetItemName;
      that.sortOrder_2 = 1;
      that.repository.sortOrder = 1;
      $sortOptionFeature.prop('disabled', false);
      $sortMenu.val('2').selectmenu('refresh');
      
      // 検索
      that.controller.clearAllSelector();
      that.searchTargetTypes = [];
      that.searchTargetTypes[facetItemId] = true;
      that.searchFromBaseMarker();
  
      // 展示トピック選択中は検索パネルの選択解除ボタンの名称を変更
      $allClearButton.prop('disabled', false);
      $allClear.find('.ui-btn-inner').css('color', 'black');
      $allClear.find('.ui-btn-text').text('企画展による選択を解除');
    });
    
    // 展示トピック選択中専用の選択解除ボタンの処理
    $allClearButton.on('click', () => {
      $allClear.find('.ui-btn-text').text('選択を解除');
      if ($topic) {
        // 展示トピック限定検索から通常検索に戻す
        $topic.prop('checked', false);
        $topic.checkboxradio();
        $topic.checkboxradio('refresh');
  
        // 並び替えを制作年代順に戻す
        that.repository.sortKey = 'year';
        that.repository.sortOrder = 1;
        $sortMenu.val('1').selectmenu('refresh');
        $sortOptionFeature.prop('disabled', true);
      }
    });
  
    // 展示トピック選択中は選択解除ボタンは常に有効にする
    $('.js-facet-selector').on('changeState', () => {
      if ($topic) {
        $allClearButton.prop('disabled', false);
        $allClear.find('.ui-btn-inner').css('color', 'black');
      }
    });
  }
};


// WEBPACK FOOTER //
// ./map/js/ih/extend/IHSakaiMucha.js